<template>
  <div class="all_part">
    <div class="head">
      <titleBlock_computer></titleBlock_computer>
    </div>
    <div class="all_input">
      <div class="all_input_top">
        <div class="all_input_left">
          <div>
            <el-input
                v-model="Opponent_name"
                placeholder="竞争对手公司名称"
                style="width: 547px"
            ></el-input>
          </div>
          <div>
            <el-select v-model="XinXiLaiYuan_Choice" placeholder="信息来源" style="width: 547px">
              <el-option
                  v-for="item in XinXiLaiYuan_Select"
                  :key="item.value"
                  :label="item.title"
                  :value="item.title"

              >
              </el-option>
            </el-select>
          </div>
          <div>
            <el-input
                v-model="customer"
                placeholder="关联客户"
                style="width: 547px"
            ></el-input>
          </div>
          <div>
            <el-input
                v-model="Competitor_salesman"
                placeholder="竞争对手业务员"
                style="width: 547px"
            ></el-input>
          </div>
        </div>
        <div class="all_input_right">
          <div>
            <el-select v-model="JinPin_Choice" placeholder="竞品产品类别" style="width: 547px">
              <el-option
                  v-for="item in JinPin_select"
                  :key="item.value"
                  :label="item.title"
                  :value="item.title"

              >
              </el-option>
            </el-select>
          </div>
          <div>
            <el-select v-model="XinXi_Choice" placeholder="信息分类" style="width: 547px">
              <el-option
                  v-for="item in XinXi_Select"
                  :key="item.value"
                  :label="item.title"
                  :value="item.title"

              >
              </el-option>
            </el-select>
          </div>
          <div>
            <el-select v-model="HangYe_Choice" placeholder="行业类别" style="width: 547px">
              <el-option
                  v-for="item in HangYe_select"
                  :key="item.value"
                  :label="item.title"
                  :value="item.title"

              >
              </el-option>
            </el-select>
          </div>
          <div>
            <el-select v-model="KeHu_Choice" placeholder="客户分类" style="width: 547px">
              <el-option
                  v-for="item in KeHu_Select"
                  :key="item.value"
                  :label="item.title"
                  :value="item.title"

              >
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="all_input_bottom">
        <el-input
            type="textarea"
            :rows="8"
            placeholder="具体描述"
            v-model="textarea"
        >
        </el-input>
      </div>
      <div class="Login_button">
        <el-upload
            class="upload-demo"
            action="http://hairong.zhongqinchina.com/api/up_files/upload"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :before-remove="beforeRemove"
            :before-upload="beforeAvatarUpload"
            :on-success="urlChange"
             multiple
            :limit="1"
            :on-exceed="handleExceed"
            :file-list="fileList">
          <el-button  type="primary" style="width:390px;margin-bottom:10px">点击上传</el-button>
        </el-upload>
        <el-button type="primary" style="height: 56px; width: 390px" @click="serchChanPinXiaoLei"
        >点击提交
        </el-button
        >
      </div>
    </div>

    <div class="Copyright_information">
      <span>Copyright © 胤舜密封EBD数据平台限内部使用 版权所有</span>
    </div>
  </div>
</template>

<script>
import titleBlock_computer from "../views/titleBlock_computer.vue";
import {httpUrl} from "../components/publics";

export default {
  data() {
    return {
      textarea:"",
      Competitor_salesman:"",//竞争对手业务员
      customer:"",//关联客户
      Opponent_name:"",//对手名称
      XinXi_Select: [],
      XinXi_Choice:"",
      JinPin_select:[],
      JinPin_Choice:"",
      HangYe_select:[],
      HangYe_Choice:"",
      KeHu_Select:[],
      KeHu_Choice:"",
      XinXiLaiYuan_Select:[],
      XinXiLaiYuan_Choice:[],
      urlImage:'',
      fileList:[],
    }
  },
  components: {
    titleBlock_computer,
  },
  mounted() {
    this.xinXiFenLei();
    this.jingPinChanPin();
    this.hangYe();
    this.KeHu();
    this.XinXiLaiYuan();
  },
  methods: {
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    beforeRemove(file, fileList) {

    },
    urlChange(e){
      console.log('url',e);
      if (e.code == 200){
        this.urlImage = e.data.img
      }
    },
    beforeAvatarUpload(file){
      console.log('file',file);
      // accept=".jpg,.jpeg,.png,.pdf,.JPG,.JPEG,.PDF,DOC"

      let fileName=file.name.substring(file.name.lastIndexOf('.')+1);
      var arr = ['png','jpeg','jpg','pdf','doc','PNG','JPEG','JPG','PDF','DOC'];
      let status = arr.findIndex((value,key)=>{
        return fileName == value
      });
      console.log('fileName',fileName,status);
      if (status == -1){
        this.$message('上传文件只能是 png、jpeg、jpg、pdf、doc格式!');
        return false
      }
      // if(!extension && !extension2) {
      //   this.$message({
      //     message: '上传文件只能是 xls、xlsx格式!',
      //     type: 'warning'
      //   });
      // }
    },
    xinXiFenLei() {
      this.axios
          .get(httpUrl + `/api/index/classification`)
          .then((response) => {
            if (response.data.code == 200) {
              this.XinXi_Select = response.data.data
              console.log(this.tableData.data)

            }
            // this.$message("搜索成功");
            console.log("success", response.data);
          })
          .catch((error) => console.log(error, "error"));
    },
    jingPinChanPin() {
      this.axios
          .get(httpUrl + `/api/index/categoryList`)
          .then((response) => {
            if (response.data.code == 200) {
              this.JinPin_select = response.data.data
              console.log(this.tableData.data)
            }
            // this.$message("搜索成功");
            console.log("success", response.data);
          })
          .catch((error) => console.log(error, "error"));
    },
    hangYe() {
      this.axios
          .get(httpUrl + `/api/index/industry`)
          .then((response) => {
            if (response.data.code == 200) {
              this.HangYe_select = response.data.data
              console.log(this.tableData.data)
            }
            // this.$message("搜索成功");
            console.log("success", response.data);
          })
          .catch((error) => console.log(error, "error"));
    },
    KeHu() {
      this.axios
          .get(httpUrl + `/api/index/customer_category  `)
          .then((response) => {
            if (response.data.code == 200) {
              this.KeHu_Select = response.data.data
              console.log(this.tableData.data)
            }
            // this.$message("搜索成功");
            console.log("success", response.data);
          })
          .catch((error) => console.log(error, "error"));
    },
    XinXiLaiYuan() {
      this.axios
          .get(httpUrl + `/api/index/source`)
          .then((response) => {
            if (response.data.code == 200) {
              this.XinXiLaiYuan_Select = response.data.data
              console.log(this.tableData.data)
            }
            // this.$message("搜索成功");
            console.log("success", response.data);
          })
          .catch((error) => console.log(error, "error"));
    },
    serchChanPinXiaoLei() {
      if (this.Opponent_name == ''&&this.XinXiLaiYuan_Choice==""&&this.customer==""&&this.JinPin_Choice==""&&this.HangYe_Choice==""&&this.KeHu_Choice==""&&this.XinXi_Choice==""&&this.textarea==""&&this.Competitor_salesman=="")
      {
        this.$message("请填写信息");
        return;
        }
      let suser_id = JSON.parse(sessionStorage.getItem('user'));
      let selectID = suser_id.id;
      console.log(this.fileList)
      this.axios
          .post(httpUrl + `/api/index/competitive_products`,this.$qs.stringify({
            competitive_name:this.Opponent_name,
            source :this.XinXiLaiYuan_Choice,
            customer:this.customer,
            category:this.JinPin_Choice,
            industry:this.HangYe_Choice,
            customer_category:this.KeHu_Choice,
            classification:this.XinXi_Choice,
            description:this.textarea,
            customer_contact:this.Competitor_salesman,
            url:this.urlImage,
            user_id:selectID,

          }))
          .then((response) => {
            if (response.data.code == 200) {
              this.$message(response.data.message)
            }
            // this.$message("搜索成功");
            console.log("success", response.data);
          })
          .catch((error) => console.log(error, "error"));
    },
    // UpdateImg() {
    //   console.log(this.fileList)
    //   this.axios
    //       .post(httpUrl + `index.php/api/up_files/upload`,this.$qs.stringify({
    //           file:this.file
    //       }))
    //       .then((response) => {
    //         if (response.data.code == 200) {
    //           this.$message(response.data.message)
    //         }
    //         // this.$message("搜索成功");
    //         console.log("success", response.data);
    //       })
    //       .catch((error) => console.log(error, "error"));
    // },
  },
  }

</script>

<style>
</style>
<style scoped>
.all_part {
  min-height: 880px;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.all_input {
  width: 100%;
  height: 70%;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;
}

.all_input_top {
  width: 58%;
  height: 30%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.all_input_left {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.all_input_right {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.Copyright_information {
  margin-bottom: 15px;
}

.all_input_bottom {
  margin-top: 10px;
  margin-bottom: 20px;
  width: 58%;
}
</style>